<template>
	
	<div>
		<h1>企业文化</h1>
		
		<br>
		<div class="m_txt">
			<div><strong>企业愿景：</strong>{{ companyInfo.vision }}</div>
			<div><br><strong>企业使命：</strong>{{ companyInfo.mission }}</div>
			<div>&nbsp;</div>
			<div><strong>核心价值观： </strong>{{ companyInfo.core_values }}</div>
			<div><br><strong>企业精神：</strong>{{ companyInfo.spirit }}</div>
			<div><br><strong>经营宗旨：</strong>{{ companyInfo.purpose }}</div>
			<div><br><strong>经营策略：</strong>{{ companyInfo.strategy }}<br>&nbsp;</div>
		</div>
		
	</div>
	
</template>

<script>
import { getCompanyInfo } from '@/api/company'

export default {
  name: 'Team',
  data() {
    return {
      companyInfo: {
        vision: '',
        mission: '',
        core_values: '',
        spirit: '',
        purpose: '',
        strategy: ''
      },
      // 核心管理团队成员信息
      managementTeam: [
        {
          id: 1,
          photo: require('../../assets/images/leader1.jpg'),
          name: '陈熙霖',
          position: '咨询委员会主任',
          introduction: '陈熙霖博士，IEEE Fellow、IAPR Fellow、CCF会士\n中科院计算技术研究所研究员，副所长\n中国计算机学会副秘书长，学术工委主任\n国家杰出青年科学基金获得者	  \n♢ 主要研究领域：计算机视觉、模式识别、多媒体技术以及多模式人机接口\n♢ 获国家自然科学二等奖1项、国家科技进步二等奖4项\n♢ IEEE Trans. on Multimedia AE、计算机学报副主编、人工智能与模式识别副主编\n♢ 担任IEEE FG 2013 / FG 2018大会主席，CVPR 2017 / 2019 / 2020，ICCV 2019等的Area Chair。'
        },
        {
          id: 2,
          photo: require('../../assets/images/leader2.jpg'),
          name: '张杰',
          position: '首席执行董事',
          introduction: '张杰博士，副研究员、硕士研究生导师\nIEEE Member, CCF会员，CCF-CV专委会执行委员\n中科苏州智能计算技术研究院工业视觉检测组负责人\n♢ 人工智能、深度学习、计算视觉领域\n♢ 计算所最高奖学金所长特别奖获得者\n♢作为项目负责人或项目骨干主持（参与）纵、横向项目经费4368万'
        },
		{
		  id: 3,
		  photo: require('../../assets/images/leader3.jpg'),
		  name: '陈扬',
		  position: '项目经理',
		  introduction: '东华大学硕士\n♢ 6年机器视觉技术研发和项目管理经验\n♢ 曾就职于无锡信捷电气股份有限公司\n♢ 国产光纤测径仪算法开发核心成员'
		},
        // 更多管理团队成员...
      ],
      // 核心研发团队成员信息
      researchTeam: [
        {
          id: 1,
          photo: require('../../assets/images/research1.jpg'),
          name: '周涵',
          position: '算法工程师',
          introduction: '7年工业视觉算法开发经验\n♢ 独立承担百万级工业视觉项目1项\n♢ 发表SCI期刊论文2篇\n♢ 专注于工业视觉算法，推动了多项核心技术的发展'
        },
		{
		  id: 2,
		  photo: require('../../assets/images/research2.jpg'),
		  name: '杨宵玲',
		  position: '算法工程师',
		  introduction: '苏州大学硕士\n♢ 台湾国立清华大学莙政学者\n♢ 8年图像算法研发经验'
		},
		{
		  id: 3,
		  photo: require('../../assets/images/research3.jpg'),
		  name: '周壮壮',
		  position: '机械工程师',
		  introduction: '哈尔滨工业大学硕士\n♢ 机械智能化经验丰富\n♢ 曾就职于苏州汇川技术有限公司'
		},
		{
		  id: 4,
		  photo: require('../../assets/images/research4.jpg'),
		  name: '孙乐康',
		  position: '软件工程师',
		  introduction: '苏州大学硕士\n♢ 拥有4年全栈开发经验\n♢ 曾领导开发多个关键项目'
		},
		{
		  id: 5,
		  photo: require('../../assets/images/research5.jpg'),
		  name: '靳雨桐',
		  position: '研发工程师',
		  introduction: '南京信息工程大学硕士\n♢ 5年算法研发经验\n♢ 发表顶刊论文4篇\n♢ 研发项目合同额超百万'
		},
        // 更多研发团队成员...
      ]
    };
  },
  async created() {
    await this.fetchCompanyInfo();
  },
  methods: {
    async fetchCompanyInfo() {
      try {
        const response = await getCompanyInfo();
        if (response.data.status === 200) {
          this.companyInfo = response.data.data;
        } else {
          console.error('获取公司信息失败:', response.data.msg);
        }
      } catch (err) {
        console.error('请求出错:', err);
      }
    }
  }
};
</script>

<style scoped>
	
	.m_txt {
	    padding: 20px 0;
	    color: #666;
	    font-size: 16px;
	    line-height: 1.8;
	    overflow: hidden;
	}
	
.team-page {
  padding: 20px;
  background-color: #f9f9f9;
}

.team-page h1 {
  text-align: center;
  margin-bottom: 40px;
}

.team-section {
  margin-bottom: 60px;
}

.team-section h2 {
  font-size: 2em;
  color: #333;
  margin-bottom: 30px;
  text-align: center;
}

.team-members {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.team-card {
  display: flex;
  align-items: center;
  background-color: #fff;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  transition: transform 0.2s;
}

.team-card:hover {
  transform: translateY(-5px);
}

.team-image {
  flex-shrink: 0;
  margin-right: 20px;
  text-align: center;
}

.team-image img {
  width: 130px;
  height: 130px;
  border-radius: 10%;
  object-fit: cover;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.team-position {
  margin-top: 10px;
  font-weight: bold;
  color: #007bff;
}

.team-info {
  flex: 1;
}

.team-info h3 {
  font-size: 1.5em;
  margin-bottom: 10px;
}

.team-info p {
	padding-left: 10px;
	text-align: left;
  /* margin: 0; */
  color: #555;
  line-height: 1.6;
}

@media (max-width: 768px) {
  .team-card {
    flex-direction: column;
    align-items: flex-start;
    text-align: left;
  }

  .team-image {
    margin-bottom: 15px;
    margin-right: 0;
  }
}

.multi-line-text {
  white-space: pre-wrap; /* 保留换行符和空白 */
}
</style>